import React from 'react';
import { useTranslation } from "react-i18next";
import { Stack, InputLabel, Box } from '@mui/material';
import DatePickerComponent from './DatePickerComponent';

function Calendario({ startDate = null, setStartDate = () => {}, endDate = null, setEndDate = () => {} }) {
  const { t } = useTranslation();

  return (
    <Stack>
      <Stack direction="row" spacing={2}>
        <Stack sx={{with:"50%"}}>
          <InputLabel
            sx={{
              color: 'white',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '15px',
              fontWeight:"500",
            }}
          >
            {t("Welcome.text194")}
          </InputLabel>
          <Box
             sx={{
              backgroundColor: 'white',
              borderRadius: '6px',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
              outline:"none",
              transition: 'box-shadow 0.3s',
              overflow: 'hidden', 
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
              },
              "& .MuiSelect-select": { 
                minHeight: "auto", 
              },
              "& .MuiOutlinedInput-root": {
                minHeight: "32px", 
              },
              
          "& .MuiInputBase-input": {
            color:  "gray",
            fontSize:"14px",
            fontFamily: "Raleway, sans-serif",
          },
            }}
          >
            <DatePickerComponent value={startDate} setValue={setStartDate} />
          </Box>
        </Stack>

        <Stack sx={{with:"50%"}}>
          <InputLabel
            sx={{
              color: 'white',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '15px',
              fontWeight:"500",
            }}
          >
            {t("Welcome.text98")}
          </InputLabel>
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: '6px',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
              outline:"none",
              transition: 'box-shadow 0.3s',
              overflow: 'hidden', 
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
              },
              "& .MuiSelect-select": { 
                minHeight: "auto", 
              },
              "& .MuiOutlinedInput-root": {
                minHeight: "32px", 
              },
              
          "& .MuiInputBase-input": {
            color:  "gray",
            fontSize:"14px",
            fontFamily: "Raleway, sans-serif",
          },
            }}
          >
            <DatePickerComponent value={endDate} setValue={setEndDate} />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Calendario;

